// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.preview-submit-button {
  min-width: 120px;
  display: inline-block;
}

.preview-submit-button::part(button) {
  width: 100%;
  min-width: 120px;
}

.preview-submit-button[disabled] {
  cursor: not-allowed !important;
  opacity: 1 !important;
}

.preview-submit-button[disabled]::part(button) {
  background-color: #d1d5db !important;
  border-color: #d1d5db !important;
  color: #6b7280 !important;
  cursor: not-allowed !important;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Preview/Preview.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;EACzB,8BAA8B;AAChC","sourcesContent":[".preview-submit-button {\n  min-width: 120px;\n  display: inline-block;\n}\n\n.preview-submit-button::part(button) {\n  width: 100%;\n  min-width: 120px;\n}\n\n.preview-submit-button[disabled] {\n  cursor: not-allowed !important;\n  opacity: 1 !important;\n}\n\n.preview-submit-button[disabled]::part(button) {\n  background-color: #d1d5db !important;\n  border-color: #d1d5db !important;\n  color: #6b7280 !important;\n  cursor: not-allowed !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
